module.exports = global["Tether"] = require("-!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
// module id = 5
// module chunks = 0